module.exports = __webpack_public_path__ + "static/media/fb-link.1af19f26.svg";